/**
 * This is separate from the panel-config to avoid circular reference - the grids use this for
 * saved views and filter groups.
 */
export const Positions2Key = 'positions-2-p7m2q' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
